import { Link, useNavigate, useParams } from 'react-router-dom';
import { TenderDetail } from './components/tender-detail.component';
import './sourcing.css';

/**
 * Full-frame detail page mounted at `/i/sourcing/:id`. The list at
 * `/i/sourcing` navigates here on row click; clicking "Zurück" pops back to
 * the list (which remembers its filter/scroll via `useGridState`).
 */
export function SourcingDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <div className="sc-main">
        <div className="sc-empty">
          <div>
            <div className="sc-empty-big">Keine Ausschreibung gewählt</div>
            <Link to="/i/sourcing" className="sc-link-btn">
              Zur Übersicht
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sc-main sc-detail-page">
      <div className="sc-detail-back-row">
        <div className="sc-detail-back-row-inner">
          <button
            type="button"
            className="sc-link-btn"
            onClick={() => navigate('/i/sourcing')}
          >
            ← Zur Übersicht
          </button>
        </div>
      </div>
      <div className="sc-detail-frame">
        <TenderDetail key={id} tenderId={id} />
      </div>
    </div>
  );
}
